export const INTERNAL_ERROR = 'Something went wrong. Please try again';
export const NAME_VALIDATION_ERROR = "Name must only contain letters, numbers, underscores (_), hyphens (-). no any spaces"